import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';

import { Observable } from 'rxjs';
import { RequestClassifier } from './domain/request-classifier';
import { Captcha } from './domain/captcha';

export function captchaInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const request = new RequestClassifier(req);
  if (!request.isForLogin() || request.hasCaptcha()) {
    return next(req);
  }

  const captcha = new Captcha(req);
  req = req.clone({
    setHeaders: {
      captcha: captcha.generate(),
    },
  });
  return next(req);
}
